export const maskFormatedId = (id: string | null): string => {
  if (id === null) return '...';
  const parts = id.split('-');
  if (parts.length < 3) return '...';
  return `...${parts[2]}`;
};
